import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import PhoneRoundedIcon from '@mui/icons-material/PhoneRounded';
import OpenInNewRoundedIcon from '@mui/icons-material/OpenInNewRounded';

const icons = new Map<string, typeof ArrowForwardRoundedIcon>([
  ['arrow_forward', ArrowForwardRoundedIcon],
  ['check', CheckRoundedIcon],
  ['phone', PhoneRoundedIcon],
  ['open_in_new', OpenInNewRoundedIcon],
]);

/** Authored icon names resolve only to bundled icons, never remote code or markup. */
export function SurveyActionIcon({
  name,
  defaultArrow = false,
}: {
  name?: string;
  defaultArrow?: boolean;
}) {
  if (name === 'none') return null;
  const Icon = icons.get(name ?? '');
  if (Icon) return <Icon aria-hidden="true" />;
  return defaultArrow ? <ArrowForwardRoundedIcon aria-hidden="true" /> : null;
}
